import React, { useEffect, useState } from 'react';
import GreyWrapper from './common/GreyWrapper';
import DropdownCard from './common/DropdownCard';
import BestValueCheckbox from './components/BestValueCheckbox';
import NoteField from './components/NoteField';
import { useSavePersonalisedPlan } from './service';
import './PersonalisedStyle.css';
import BulletPointTextarea from './components/BulletPointTextarea ';
import SharePlanModal from './components/SharePlanModal';

export const buildEmailContent = (
  studentName: string,
  coachName: string,
  conciergeName: string,
  shortUrl: string
) => {
  return `
    <table class="row row-2" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
    <tbody>
        <tr>
        <td>
            <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #fff8f2; border-bottom: 1px solid #f1dfd0; border-left: 1px solid #f1dfd0; border-radius: 7px; border-right: 1px solid #f1dfd0; border-top: 1px solid #f1dfd0; color: #000000; width: 600px; margin: 0 auto;" width="600">
            <tbody>
                <tr>
                <td class="column column-1" width="100%" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; padding-top: 5px; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;">

                <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                    <tbody>
                        <tr>
                            <td style="padding-bottom:20px;padding-left:40px;padding-top:40px;text-align:center;width:100%">
                                <h1
                                    style="margin:0;color:#ff6a00;direction:ltr;font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;font-size:22px;font-weight:700;letter-spacing:normal;line-height:120%;text-align:left;margin-top:0;margin-bottom:0">
                                    <span style="word-break:break-word">${studentName}, your personalised yoga journey starts now!</span>
                                </h1>
                            </td>
                        </tr>
                    </tbody>
                </table>

                    <!-- Heading 2 -->
                    <table class="heading_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                        <tr>
                        <td class="pad" style="padding-left:40px;padding-right:40px;text-align:center;width:100%;">
                        <h1 style="margin: 0; color: #8e6445; direction: ltr; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; font-weight: 400; letter-spacing: normal; line-height: 150%; text-align: left; margin-top: 0; margin-bottom: 0; mso-line-height-alt: 16.8px;">
                            <span class="tinyMce-placeholder" style="word-break: break-word;">
                            Your teacher <strong style="margin-left:4px; margin-right:4px;">${coachName}</strong> and advisor <strong style="margin-left:4px; margin-right:4px;">${conciergeName}</strong> have designed a personalised yoga plan to help you:
                            </span>
                                </h1>
                            </td>
                        </tr>
                </table>

                    <!-- List of benefits -->
                    <table class="heading_block block-3" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                    <tr>
                        <td class="pad" style="padding-top:5px;text-align:center;width:100%;">

                        <div style="display:flex;padding-left: 40px; margin-top: 20px">
                            <img src="https://cloudimages.myyogateacher.com/dgerdfai4/image/upload/v1708945658/Lv-landingpage/Tick.png" style="width:18px; height:18px; margin-right:5px">
                            <div>
                            <p style="margin-bottom:0;margin-top:0;text-align:left;font-family: Helvetica;font-size: 14px;font-style: normal;font-weight: 700;line-height: normal;color: #8E6445">
                                Achieve your health & wellness goals
                            </p>
                            </div>
                        </div>

                        <div style="display:flex;padding-left: 40px; margin-top: 20px">
                            <img src="https://cloudimages.myyogateacher.com/dgerdfai4/image/upload/v1708945658/Lv-landingpage/Tick.png" style="width:18px; height:18px; margin-right:5px">
                            <div>
                            <p style="margin-bottom:0;margin-top:0;text-align:left;font-family: Helvetica;font-size: 14px;font-style: normal;font-weight: 700;line-height: normal;color: #8E6445">
                                Stay consistent with expert guidance
                            </p>
                            </div>
                        </div>

                        <div style="display:flex;padding-left: 40px; margin-top: 20px">
                            <img src="https://cloudimages.myyogateacher.com/dgerdfai4/image/upload/v1708945658/Lv-landingpage/Tick.png" style="width:18px; height:18px; margin-right:5px">
                            <div>
                            <p style="margin-bottom:0;margin-top:0;text-align:left;font-family: Helvetica;font-size: 14px;font-style: normal;font-weight: 700;line-height: normal;color: #8E6445">
                                Progress at a pace that suits your lifestyle
                            </p>
                            </div>
                        </div>

                        <p style="padding-left: 40px;margin-bottom:0;margin-top:22px;text-align:left;font-family: Helvetica;font-size: 15px;font-style: normal;font-weight: 500;line-height: normal;color: #8E6445">
                            Your customised journey is ready — let’s take the first step together!
                        </p>

                        </td>
                    </tr>
                    </table>

                    <!-- Button -->
                    <table class="button_block block-4" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                    <tr>
                        <td class="pad" style="padding-left:40px;padding-top:20px;text-align:left;">
                        <div class="alignment" align="left">
                            <!--[if mso]>
                            <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{.session_token}}" style="height:56px;width:346px;v-text-anchor:middle;" arcsize="15%" stroke="false" fillcolor="#ee731b">
                            <w:anchorlock/>
                            <v:textbox inset="0px,0px,0px,0px">
                            <center dir="false" style="color:#fff;font-family:Arial, sans-serif;font-size:16px">
                            <![endif]-->
                            <a href="${shortUrl}" target="_blank" style="background-color:#ee731b;border-bottom:0px solid transparent;border-left:0px solid transparent;border-radius:8px;border-right:0px solid transparent;border-top:0px solid transparent;color:#fff;display:inline-block;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:16px;font-weight:400;mso-border-alt:none;padding-bottom:0px;padding-top:0px;text-align:center;text-decoration:none;width:auto;word-break:keep-all;">
                            <span style="word-break: break-word; padding-left: 18px; padding-right: 18px; font-size: 16px; display: inline-block; letter-spacing: normal; padding-top: 9px; padding-bottom: 9px; border-radius: 14px; display:flex; align-items: center">
                                <span style="word-break: break-word;">
                                <span class style="word-break: break-word; line-height: 32px;" data-mce-style>
                                    View My Personalised Plan
                                </span>
                                </span>
                            </span>
                            </a>
                            <!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
                        </div>
                        </td>
                    </tr>
                    </table>

                    <!-- Paragraph -->
                    <table class="paragraph_block block-5" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;">
                    <tr>
                        <td class="pad" style="padding-left:40px;padding-right:40px;padding-top:20px;padding-bottom:40px">
                        <div style="color:#8e6445;direction:ltr;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:15px;font-weight:400;letter-spacing:0px;line-height:150%;text-align:left;mso-line-height-alt:22.5px;">
                            <p style="margin: 0;">
                            We believe in your potential — thousands have transformed with MyYogaTeacher, now it’s your turn.
                            </p>
                        </div>
                        </td>
                    </tr>
                    </table>
                </td>
                </tr>
            </tbody>
            </table>
        </td>
        </tr>
    </tbody>
    </table>
  `;
};

// ---------------- Types ----------------
interface Plan {
  sessions_per_week: number | null;
  months: number | null;
  is_best_value: boolean;
  type: string;
}

interface GroupClass {
  uuid: string;
  name: string;
}

interface Notes {
  coach: string;
  ai: string;
  selected: 'teacher' | 'ai';
}

interface Lifestyle {
  current: string[];
  goals: string[];
}

interface PersonalisedPriceProps {
  studentDetails: {
    student_uuid: string;
    first_name: string;
    student_concierge_name: string;
  };
  data: any;
}

const INITIAL_PLAN: Plan = {
  sessions_per_week: 0,
  months: null,
  is_best_value: false,
  type: ''
};

const INITIAL_NOTES: Notes = {
  coach:
    'Great work in class today. You brought a steady energy to the mat, and I really noticed how your breath stayed connected throughout the flow.',
  ai: 'Great work in class today. You brought a steady energy to the mat, and I really noticed how your breath stayed connected throughout the flow.',
  selected: 'teacher'
};

// ---------------- Component ----------------
const PersonalisedPlan: React.FC<PersonalisedPriceProps> = ({ studentDetails, data }) => {
  const [showSavedPlans, setShowSavedPlans] = useState(false);
  const [availablePlans, setAvailablePlans] = useState<any[]>([]);
  const [availableGroupClasses, setAvailableGroupClasses] = useState<GroupClass[]>([]);
  const [selectedPlanData, setSelectedPlanData] = useState({
    plans: [INITIAL_PLAN, INITIAL_PLAN, INITIAL_PLAN],
    recommended_group_classes: [] as GroupClass[],
    notes: INITIAL_NOTES,
    lifestyle: { current: [], goals: [] } as Lifestyle
  });
  const [errorMsg, setErrorMsg] = useState('');

  const { savePersonalisedPlan, shortUrl } = useSavePersonalisedPlan(studentDetails?.student_uuid);
  const formattedStudentFirstName =
    studentDetails?.first_name && studentDetails?.first_name.length > 0
      ? studentDetails?.first_name.charAt(0).toUpperCase() + studentDetails?.first_name.slice(1)
      : '';

  // ---------- Prefill data ----------
  useEffect(() => {
    if (data) {
      setAvailablePlans(data.available_plans || []);
      setAvailableGroupClasses(data.available_group_classes || []);

      // Prefill chosen plans
      const prefilledPlans = (data.chosen_plans || []).map((plan: any) => ({
        sessions_per_week: plan.sessions_per_week ?? 0,
        months: plan.months ?? null,
        is_best_value: plan.is_best_value ?? false,
        type: plan.type === 'Group Class' ? 'gc' : plan.type || ''
      }));

      while (prefilledPlans.length < 3) {
        prefilledPlans.push(INITIAL_PLAN);
      }

      // Prefill notes
      let prefilledNotes = {
        coach: '',
        ai: '',
        selected: 'teacher' as 'teacher' | 'ai'
      };

      if (Array.isArray(data.notes)) {
        const teacherNote = data.notes.find((n: any) => n.note_type === 'teacher');
        const aiNote = data.notes.find((n: any) => n.note_type === 'ai');

        prefilledNotes = {
          coach: teacherNote?.note || '',
          ai: aiNote?.note || '',
          selected: teacherNote?.selected ? 'teacher' : aiNote?.selected ? 'ai' : 'teacher'
        };
      }

      // Parse goals if available
      let parsedGoals: string[] = [];
      const sourceGoals = data.main_goals ?? data.goals ?? null;
      if (Array.isArray(sourceGoals)) {
        parsedGoals = sourceGoals
          .map((g: any) => (typeof g === 'string' ? g.trim() : String(g)))
          .filter((g: string) => g.length > 0);
      } else if (typeof sourceGoals === 'string' && sourceGoals.length > 0) {
        parsedGoals = sourceGoals
          .split(',')
          .map((goal: string) => goal.trim())
          .filter((goal: string) => goal.length > 0);
      }

      setSelectedPlanData((prev) => ({
        ...prev,
        notes: prefilledNotes,
        lifestyle: {
          current: data.lifestyle || [],
          goals: parsedGoals.length > 0 ? parsedGoals : data.goals || []
        },
        plans: prefilledPlans,
        recommended_group_classes: data.chosen_group_classes || []
      }));
    }
  }, [data, studentDetails]);

  // ---------- Handlers ----------
  const updatePlanField = (index: number, field: keyof Plan, value: any) => {
    setSelectedPlanData((prev) => {
      const plans = [...prev.plans];
      plans[index] = { ...plans[index], [field]: value };
      return { ...prev, plans };
    });
  };

  const toggleBestValue = (index: number, checked: boolean) => {
    setSelectedPlanData((prev) => {
      const plans = [...prev.plans];

      if (checked) {
        plans.forEach((plan, i) => {
          if (i !== index) {
            plan.is_best_value = false;
          }
        });
      }
      plans[index] = { ...plans[index], is_best_value: checked };

      return { ...prev, plans };
    });
  };

  const selectGroupClass = (index: number, gcName: string) => {
    const selected = availableGroupClasses.find((g) => g.name === gcName);
    if (!selected) return;

    setSelectedPlanData((prev) => {
      const rec = [...prev.recommended_group_classes];
      // ensure array has enough slots
      while (rec.length <= index) {
        rec.push({ uuid: '', name: '' } as GroupClass);
      }
      rec[index] = selected;
      return { ...prev, recommended_group_classes: rec };
    });
  };

  const updateNotes = (field: keyof Notes, value: string) => {
    setSelectedPlanData((prev) => ({
      ...prev,
      notes: { ...prev.notes, [field]: value }
    }));
  };

  const updateLifestyle = (type: keyof Lifestyle, values: string[]) => {
    setSelectedPlanData((prev) => ({
      ...prev,
      lifestyle: { ...prev.lifestyle, [type]: values }
    }));
  };

  const onSavePlan = async () => {
    // --- Validation start ---
    const hasPlanSelected = selectedPlanData.plans.some((plan) => plan.type && plan.type !== '');
    if (!hasPlanSelected) {
      setErrorMsg('Please select at least one plan before saving.');
      return;
    }

    const isConciergeSelected = studentDetails?.student_concierge_name;
    if (!isConciergeSelected) {
      setErrorMsg('Please assign a concierge to the student before saving the plan.');
      return;
    }

    // --- Proceed with saving if validation passes ---
    // Validate required fields for each selected plan
    for (const plan of selectedPlanData.plans) {
      if (plan.type === '1on1') {
        if (!plan.months || !plan.sessions_per_week) {
          setErrorMsg(
            'For Private 1-on-1 Sessions, please select both Plan Duration and Sessions per Week.'
          );
          return;
        }
      } else if (plan.type === 'gc') {
        if (!plan.months) {
          setErrorMsg('For Group Class, please select Plan Duration.');
          return;
        }
      }
    }
    // Validate Lifestyle and Goals are provided
    const currentLifestyle = selectedPlanData.lifestyle.current || [];
    const goalsList = selectedPlanData.lifestyle.goals || [];

    if (!Array.isArray(currentLifestyle) || currentLifestyle.length === 0) {
      setErrorMsg('Please fill Current Lifestyle before saving.');
      return;
    }

    if (!Array.isArray(goalsList) || goalsList.length === 0) {
      setErrorMsg('Please fill Goals before saving.');
      return;
    }

    // Validate Coach notes is provided
    const coachNote = (selectedPlanData.notes?.coach || '').toString().trim();
    if (!coachNote) {
      setErrorMsg('Please fill Coach notes before saving.');
      return;
    }

    const payload = {
      plans: selectedPlanData.plans,
      recommended_group_classes: selectedPlanData.recommended_group_classes.filter(
        (gc) => gc?.uuid
      ),
      notes: selectedPlanData.notes,
      lifestyle: currentLifestyle,
      goals: goalsList
    };

    try {
      await savePersonalisedPlan(payload);
      console.log('Saved successfully');
      setShowSavedPlans(true);
    } catch (err) {
      console.error('Save failed', err);
    }
  };

  useEffect(() => {
    if (errorMsg) {
      setErrorMsg('');
    }
  }, [selectedPlanData]);

  const groupClassOptions = availableGroupClasses.map((gc) => gc.name);

  if (showSavedPlans || data?.short_url) {
    // Build a safe studentDetails object for SharePlanModal to satisfy its prop types
    const shareStudentDetails = {
      email: (studentDetails as any)?.email || '',
      student_uuid: (studentDetails as any)?.student_uuid || '',
      last_name: (studentDetails as any)?.last_name || '',
      first_name: (studentDetails as any)?.first_name || '',
      message_dispatch_method: (studentDetails as any)?.message_dispatch_method || '',
      is_allowed_whatsapp: Boolean((studentDetails as any)?.is_allowed_whatsapp),
      is_allowed_sms: Boolean((studentDetails as any)?.is_allowed_sms)
    };

    return (
      <SharePlanModal
        smsContent={`Hi ${formattedStudentFirstName},

Your personalised plan has been prepared by teacher ${data?.coach_name} and advisor ${studentDetails.student_concierge_name}.

You can now view it here: ${data?.short_url || shortUrl}

If you have any questions, feel free to reach out.`}
        emailSubject={`Begin your yoga journey today — your personalised plan is ready, ${formattedStudentFirstName}!`}
        emailContent={buildEmailContent(
          formattedStudentFirstName,
          data?.coach_name,
          studentDetails.student_concierge_name,
          data?.short_url || shortUrl
        )}
        studentDetails={shareStudentDetails}
        personalisedData={data}
      />
    );
  }

  return (
    <div className="personalised-pricing font-[inter] max-w-[1000px] px-[20px] pb-[20px]">
      <h2 className="text-[19px] font-bold leading-[22px]">Personalised Plans</h2>
      <p className="text-[#939393] leading-[26px]">
        Select the options below to create a personalised plan.
      </p>

      {/* ---------- Plan Selection ---------- */}
      <div className="grid grid-cols-2 gap-[20px]">
        {selectedPlanData.plans.map((plan, index) => {
          const planDef = availablePlans.find((p) => p.type === plan.type);

          return (
            <div key={index} className="w-full flex flex-col gap-[6px]">
              <div className="text-[#838383] text-[10.5px] font-[625] leading-[18px]">
                {`PLAN ${['ONE', 'TWO', 'THREE'][index]}`}
              </div>
              <GreyWrapper>
                {/* --- Plan Type Dropdown --- */}
                <DropdownCard
                  value={
                    plan.type
                      ? plan.type === '1on1'
                        ? 'Private 1-on-1 Sessions'
                        : 'Group Class'
                      : null
                  }
                  label="Select a plan type"
                  items={availablePlans.map((p) =>
                    p.type === '1on1' ? 'Private 1-on-1 Sessions' : 'Group Class'
                  )}
                  onSelect={(val) =>
                    updatePlanField(index, 'type', val === 'Group Class' ? 'gc' : '1on1')
                  }
                />

                {/* --- Only show duration + sessions/best value if plan chosen --- */}
                {plan.type && (
                  <>
                    <div className="flex gap-[20px] mt-4">
                      {/* Plan Duration */}
                      <div className="w-full">
                        <p className="mt-[21px] mb-[8px]">Plan Duration</p>
                        <DropdownCard
                          value={
                            plan.months ? `${plan.months} Month${plan.months > 1 ? 's' : ''}` : null
                          }
                          label="Select Duration"
                          items={
                            planDef?.months?.map((m: number) => `${m} Month${m > 1 ? 's' : ''}`) ||
                            []
                          }
                          onSelect={(val) => updatePlanField(index, 'months', parseInt(val))}
                        />
                      </div>

                      {/* Sessions per week only for 1on1 */}
                      {plan.type === '1on1' && (
                        <div className="w-full">
                          <p className="mt-[21px] mb-[8px]">Sessions per Week</p>
                          <DropdownCard
                            value={plan.sessions_per_week ? `${plan.sessions_per_week}` : null}
                            label="Select Sessions"
                            items={planDef?.sessions_per_week?.map((s: number) => `${s}`) || []}
                            onSelect={(val) =>
                              updatePlanField(index, 'sessions_per_week', parseInt(val))
                            }
                          />
                        </div>
                      )}
                    </div>

                    {/* Best Value checkbox always visible if plan selected */}
                    <BestValueCheckbox
                      checked={plan.is_best_value}
                      onChange={(checked) => toggleBestValue(index, checked)}
                    />
                  </>
                )}
              </GreyWrapper>
            </div>
          );
        })}
      </div>

      {/* ---------- Group Classes ---------- */}
      <div className="w-full flex flex-col mt-6">
        <div className="flex w-full items-center justify-between">
          <p className="text-[#838383] text-[10.5px] font-[625] uppercase">
            Recommend group classes
          </p>
          <p className="text-[#838383] text-[10.5px] font-[625]">Optional</p>
        </div>
        <GreyWrapper customStyle="flex gap-[20px]">
          <DropdownCard
            value={selectedPlanData.recommended_group_classes[0]?.name || null}
            label="Select Group class 1"
            items={groupClassOptions}
            onSelect={(val) => selectGroupClass(0, val)}
            searchable={true}
          />
          <DropdownCard
            value={selectedPlanData.recommended_group_classes[1]?.name || null}
            label="Select Group class 2"
            items={groupClassOptions}
            onSelect={(val) => selectGroupClass(1, val)}
            searchable={true}
          />
        </GreyWrapper>
      </div>

      {/* ---------- Notes ---------- */}
      <div className="mt-[40px] mb-[10px] text-[16.5px] font-[550]">Notes</div>
      <GreyWrapper customStyle="flex gap-[20px]">
        <NoteField
          label="Coach notes"
          id="coach"
          value={selectedPlanData.notes.coach}
          onChange={(val) => updateNotes('coach', val)}
          isSelected={selectedPlanData.notes.selected === 'teacher'}
          onSelect={() => updateNotes('selected', 'teacher')}
        />
        <NoteField
          label="Ai notes"
          id="ai"
          value={selectedPlanData.notes.ai}
          onChange={(val) => updateNotes('ai', val)}
          isSelected={selectedPlanData.notes.selected === 'ai'}
          onSelect={() => updateNotes('selected', 'ai')}
        />
      </GreyWrapper>

      {/* ---------- Goals / Lifestyle ---------- */}
      <div className="mt-[40px] mb-[10px] text-[16.5px] font-[550]">Goals/Lifestyle Section</div>
      <GreyWrapper customStyle="flex gap-[20px]">
        <BulletPointTextarea
          value={selectedPlanData.lifestyle.current}
          onChange={(values) => updateLifestyle('current', values)}
          label="Current Lifestyle"
          placeholder="Start typing your notes..."
        />
        <BulletPointTextarea
          value={selectedPlanData.lifestyle.goals}
          onChange={(values) => updateLifestyle('goals', values)}
          label="Goals"
          placeholder="Start typing your notes..."
        />
      </GreyWrapper>

      <div className="mt-4">
        <button
          onClick={onSavePlan}
          className="w-fit border-0 font-medium py-2 rounded-[14px] bg-[#EE731B] text-white hover:bg-[#CC4B11] hover:text-white cursor-pointer"
        >
          Save Plans
        </button>

        {errorMsg && (
          <p className="text-[#FF2121] md:text-[15.5px] zm:text-[12.5px] font-medium my-[10px] ">
            {errorMsg}
          </p>
        )}
      </div>
    </div>
  );
};

export default PersonalisedPlan;
